import React from "react";
import "./App.css";
import Home from "./page/Home";
import VisionPage from "./page/VisionPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HistoryPage from "./page/HistoryPage";
import { TeamPage } from "./page/TeamPage";
import { ResultPage } from "./page/BusinessResultPage";
import { ResearchPage } from "./page/ResearchPage";
import { SimIntroPage } from "./page/SimIntroPage";
import { SimFeaturePage } from "./page/SimFeaturePage";
import { SimContentPage } from "./page/SimContentPage";
import { ElderyContentPage } from "./page/ElderyContentPage";
// import { TestPage } from "./page/TestPage";
import MbaIntroPage from "./page/MbaIntroPage";
import MbaContentPage from "./page/MbaContentPage";
import SSSBisIntroPage from "./page/3sBisIntroPage";
import SSSBisContentPage from "./page/3sBisContentPage";
import ElderyIntroPage from "./page/ElderyIntroPage";
import { ElderyContentPage2 } from "./page/ElderyContentPage2";
import { ElderyContentPage3 } from "./page/ElderyContentPage3";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/vision" element={<VisionPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/research" element={<ResearchPage />} />

          <Route path="/simintro" element={<SimIntroPage />} />
          <Route path="/simfeature" element={<SimFeaturePage />} />
          <Route path="/simcontent" element={<SimContentPage />} />

          <Route path="/eldintro" element={<ElderyIntroPage />} />
          <Route path="/eldcontent" element={<ElderyContentPage />} />
          <Route path="/eldcontent2" element={<ElderyContentPage2 />} />
          <Route path="/eldcontent3" element={<ElderyContentPage3 />} />

          <Route path="/mba4intro" element={<MbaIntroPage />} />
          <Route path="/mba4content" element={<MbaContentPage />} />

          <Route path="/3sbisintro" element={<SSSBisIntroPage />} />
          <Route path="/3sbiscontent" element={<SSSBisContentPage />} />

          {/* <Route path="/test" element={<TestPage />} /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
